import Vue, { CreateElement } from 'vue'
import { Button } from '@src/elements/button/button'
import { Subtitle1, Subtitle2 } from '@src/elements/typography/typography'
import type { WorkoutLiveData } from '@src/state/store'
import { Prop } from 'vue-property-decorator'
import { Icon } from '@src/elements/icon/icon'
import { WorkoutExercise } from '@src/data/workout-exercise'
import WorkoutData from '@src/data/workout-data'
import Component from 'vue-class-component'

import './live-workout.sass'
import {
  MobileLandscapeNotSupportedOverlay
} from '@src/components/mobile-landscape-not-supported-overlay/MobileLandscapeNotSupportedOverlay'

@Component
export class WorkoutExecution extends Vue {

  @Prop({ required: true })
  workout: WorkoutData

  @Prop({ required: true })
  workoutLiveData: WorkoutLiveData

  @Prop({ required: true })
  videoAutoplay: boolean

  @Prop({ required: true })
  currentExercise: WorkoutExercise

  @Prop({ required: true })
  svgCircleSettings: any

  @Prop({ required: true })
  exerciseStepsDescription: string[][]

  @Prop({ required: true })
  details: any[]

  @Prop({ required: true })
  timerString: string

  @Prop({ required: true })
  closePage: () => void

  @Prop({ required: true })
  updateWorkoutStateButton: () => void

  @Prop({ required: true })
  videoUrl: string

  render (h: CreateElement) {
    const { repetitions, isWorkoutPaused, currentExerciseIndex } = this.workoutLiveData
    const totalRepetitionsPerExercise = this.currentExercise!.initialExerciseConfig!.repetitions || 0
    const exerciseName = this.$te(`EXERCISE[${this.currentExercise.exercise.number}].NAME`) ?
      this.$t(`EXERCISE[${this.currentExercise.exercise.number}].NAME`) : this.currentExercise.exercise.name

    return (
      <div class='live-workout-wrapper'>
        <MobileLandscapeNotSupportedOverlay />
        <div class='video-wrapper'>
          <div class='metrics-wrapper'>
            <div class='workout-progress' style={{
              width: this.svgCircleSettings.outerRadius + 'px',
              height: this.svgCircleSettings.outerRadius + 'px'
            }}>
              <svg xmlns='http://www.w3.org/2000/svg' width={this.svgCircleSettings.outerRadius}
                   height={this.svgCircleSettings.outerRadius}>
                <circle r={this.svgCircleSettings.innerRadius} cy={this.svgCircleSettings.radius}
                        cx={this.svgCircleSettings.radius} stroke-width={6}
                        stroke='#E4E4E4' fill='transparent'/>
                <circle class='progress' r={this.svgCircleSettings.innerRadius}
                        cy={this.svgCircleSettings.radius} cx={this.svgCircleSettings.radius} stroke-width={6}
                        fill='transparent' stroke-dasharray={this.svgCircleSettings.circumference}
                        stroke-dashoffset={this.svgCircleSettings.progressOffset}
                        style={{ transition: '500ms ease-out' }}/>
              </svg>
              <div class='workout-progress-details'>
                <Subtitle1>{`${repetitions}/${totalRepetitionsPerExercise}`}</Subtitle1>
                <Subtitle2>{this.$t('PROMPTS.REPETITIONS')}</Subtitle2>
              </div>
            </div>
            <div class='timer'>{this.timerString}</div>
          </div>
          <Button class='leave-workout' type='outline' label={this.$t('LEAVE_WORKOUT')} click={
            () => this.closePage()}/>
          <video
            id='exercise-video-execution'
            ref={'exercise-video'}
            class={`${this.currentExercise.side !== 'right' ? '' : 'mirrored'}`}
            autoPlay={this.videoAutoplay}
            loop
            src={this.videoUrl}
            playsInline
          />
        </div>
        <div class='live-data-wrapper'>
          <div class='live-data'>
            <div class='exercise-name'>
              <Subtitle1>{exerciseName}</Subtitle1>
            </div>
            <div class='workout-data'>
              <div class='exercise-info-wrapper'>
                <div class='exercise-flex-container'>
                  {
                    this.details.map(({ icon, label }) => (
                      <div class={`exercise-info-item ${icon.indexOf('no-equipment') >= 0 ? 'no-equipment' : ''}`}>
                        <Icon name={icon}/>
                        <Subtitle2>{label}</Subtitle2>
                      </div>
                    ))
                  }
                </div>
                <div class='exercise-info-spacer'/>
              </div>
              <div class='initial-steps'>
                {this.exerciseStepsDescription[currentExerciseIndex].map((key, index) => {
                  const message = this.$t(`EXERCISE[${this.workout.workoutExercises[currentExerciseIndex].exercise.number}].PREPARATION_INSTRUCTIONS.${key}.DEFAULT`) as string
                  return <div>
                    <Subtitle2><span
                      class='bold'>{message.substring(0, message.indexOf(' '))}</span> {message.substring(message.indexOf(' ') + 1)}
                    </Subtitle2>
                  </div>
                })}
              </div>
              <div class='button-wrapper'>
                <div class='state-workout-button' onClick={this.updateWorkoutStateButton}>
                  {isWorkoutPaused ? this.$t('CONTINUE') : this.$t('PAUSE')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
